import { memo } from "react";

import { QuestionOptionName as Question } from "@/components/features/items/edit/option/_shared/ui/components/name/name";

import { useOptionName } from "./hooks";

export const QuestionOptionName = memo(() => {
	const { name, onSetName } = useOptionName();

	return <Question name={name} onSetName={onSetName} />;
});

QuestionOptionName.displayName = "QuestionOptionName";
